export const GUIDE_REQUEST_RESPONSE_ERROR = 'GUIDE_REQUEST_RESPONSE_ERROR';

export const guideRequestResponseError = (error) => {
    return {
        type: GUIDE_REQUEST_RESPONSE_ERROR,
        error
    };
}